// extracted by mini-css-extract-plugin
export default {"inputMinSize":"input_inputMinSize__LplK2","inputMinSizeLarge":"input_inputMinSizeLarge__7vYUb","BCTextarea":"input_BCTextarea__QGcyx"};